import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.314561,96.8176248 C773.456546,96.8176248 621.452875,248.821296 621.452875,435.679312 L621.452875,919.767436 C621.452875,1106.62545 773.456546,1258.62912 960.314561,1258.62912 C1147.17258,1258.62912 1299.17625,1106.62545 1299.17625,919.767436 L1299.17625,435.679312 C1299.17625,248.821296 1147.17258,96.8176248 960.314561,96.8176248 M427.817625,709.983006 L427.817625,943.4103 C427.817625,1236.96134 666.763523,1475.90724 960.314561,1475.90724 C1253.8656,1475.90724 1492.8115,1236.96134 1492.8115,943.4103 L1492.8115,709.983006 L1589.62912,709.983006 L1589.62912,943.4103 C1589.62912,1274.11677 1333.19106,1546.07818 1008.72823,1570.88121 L1008.723,1823.182 L1250.76744,1823.18238 L1250.76744,1920 L669.861687,1920 L669.861687,1823.18238 L911.905,1823.182 L911.900895,1570.88121 C587.438064,1546.07818 331,1274.11677 331,943.4103 L331,709.983006 L427.817625,709.983006 Z M960.314561,0 C1200.51909,0 1395.99387,195.474785 1395.99387,435.679312 L1395.99387,919.767436 C1395.99387,1159.97196 1200.51909,1355.44675 960.314561,1355.44675 C720.110034,1355.44675 524.63525,1159.97196 524.63525,919.767436 L524.63525,435.679312 C524.63525,195.474785 720.110034,0 960.314561,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMicLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMicLine, _Component);

  var _super = _createSuper(IconMicLine);

  function IconMicLine() {
    _classCallCheck(this, IconMicLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMicLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMic",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMicLine.displayName = "IconMicLine";
  return IconMicLine;
}(Component);

IconMicLine.glyphName = 'mic';
IconMicLine.variant = 'Line';
IconMicLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMicLine;
export { IconMicLine };